import * as React from "react"
import { SVGProps, memo } from "react"

type LogoVariant = "default" | "with-icon" | "wordmark"

interface LogoProps extends SVGProps<SVGSVGElement> {
  variant?: LogoVariant
}

const DefaultLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={62} height={30} fill="none" {...props}>
    <path fill="#171717" d="M62 0H0v21.928a5 5 0 0 0 4.732 4.993l52 2.796A5 5 0 0 0 62 24.724V0Z" />
    <path
      fill="#F6F6F6"
      d="m8.46 13.277-1.362-.073.153-2.843 1.362.074.147-2.723 3.423.185-.147 2.723 2.242.12-.154 2.843-2.242-.12-.242 4.483c-.036.66.23.956.99.997l1.222.066-.157 2.9-1.742-.094c-2.321-.125-3.89-1.193-3.734-4.096l.24-4.442ZM20.451 10.914A3.893 3.893 0 0 1 23.8 12.84l.085-1.582 3.424.185-.604 11.17-3.422-.184.085-1.582a3.957 3.957 0 0 1-3.557 1.554c-2.722-.147-4.783-2.507-4.593-6.03.19-3.523 2.491-5.607 5.233-5.458Zm.84 3.036c-1.282-.069-2.495.83-2.59 2.61-.097 1.782 1.01 2.846 2.291 2.915 1.3.07 2.495-.849 2.591-2.63.097-1.783-.992-2.824-2.293-2.895ZM36.487 11.854c2.763.15 4.806 2.467 4.615 5.991-.19 3.524-2.492 5.648-5.235 5.5a3.932 3.932 0 0 1-3.35-1.908L32.431 23l-3.423-.185.8-14.814 3.423.185-.282 5.225a3.95 3.95 0 0 1 3.537-1.556Zm-1.181 2.928c-1.282-.07-2.495.849-2.592 2.63-.096 1.782 1.012 2.826 2.293 2.895 1.3.07 2.516-.868 2.613-2.65.096-1.782-1.012-2.805-2.314-2.875ZM50.257 12.522c2.762.15 4.805 2.466 4.615 5.99-.19 3.525-2.493 5.648-5.236 5.5a3.932 3.932 0 0 1-3.35-1.907l-.084 1.561-3.424-.185.8-14.813 3.423.185-.282 5.225a3.95 3.95 0 0 1 3.538-1.556Zm-1.182 2.928c-1.282-.07-2.495.849-2.591 2.63-.097 1.781 1.012 2.825 2.292 2.894 1.3.07 2.517-.867 2.613-2.65.096-1.782-1.013-2.804-2.314-2.874Z"
    />
  </svg>
)

const LogoWithIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={75} height={19} viewBox="0 0 75 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_6160_7303)">
      <path
        d="M44.9904 18.7767L44.9753 6.88599H41.4692V8.16469C40.5761 7.33873 39.3753 6.88599 37.93 6.88599C35.0032 6.88599 32.6287 9.5994 32.6287 12.943C32.6287 16.2866 35.0002 19 37.93 19C39.6709 19 40.7451 18.3637 41.4692 17.4307V18.7767H44.9904ZM38.7446 15.9715C37.239 15.9715 36.017 14.5551 36.017 12.8084C36.017 11.0616 37.239 9.64528 38.7446 9.64528C40.2503 9.64528 41.4722 11.0616 41.4722 12.8084C41.4722 14.5551 40.2503 15.9715 38.7446 15.9715Z"
        fill="white"
      />
      <path
        d="M29.3157 15.3444C29.2764 16.2407 30.1514 16.1581 30.2088 16.1642H31.826V18.7828C31.7717 18.7828 30.3566 18.7828 28.8299 18.7828C26.2018 18.7889 25.4868 16.6628 25.4777 16.2621V9.58105H24.0717V6.87681H25.4777V3.87891H29.3458V6.87681H31.823V9.58105H29.3036C29.3036 9.58105 29.3096 15.3168 29.3096 15.3383L29.3157 15.3444Z"
        fill="white"
      />
      <path
        d="M54.721 6.86459C53.1037 6.86459 51.8546 7.4091 50.9675 8.30848V2.80518H46.9636V18.7859H50.9675V17.0789C52.0236 18.2628 53.4387 19 54.721 19C57.8891 19 60.1159 16.2835 60.1159 12.9308C60.1159 9.578 58.0189 6.86153 54.721 6.86153V6.86459ZM53.6861 15.843C52.1835 15.843 50.9675 14.4909 50.9675 12.8237C50.9675 11.1565 52.1835 9.80437 53.6861 9.80437C55.1887 9.80437 56.4046 11.1565 56.4046 12.8237C56.4046 14.4909 55.1887 15.843 53.6861 15.843Z"
        fill="white"
      />
      <path
        d="M69.6021 6.86459C67.9848 6.86459 66.7357 7.4091 65.8486 8.30848V2.80518H61.8447V18.7859H65.8486V17.0789C66.9047 18.2628 68.3198 19 69.6021 19C72.7702 19 74.997 16.2835 74.997 12.9308C74.997 9.578 72.9 6.86153 69.6021 6.86153V6.86459ZM68.5672 15.843C67.0646 15.843 65.8486 14.4909 65.8486 12.8237C65.8486 11.1565 67.0646 9.80437 68.5672 9.80437C70.0698 9.80437 71.2857 11.1565 71.2857 12.8237C71.2857 14.4909 70.0698 15.843 68.5672 15.843Z"
        fill="white"
      />
      <path
        d="M20.2911 16.5374L18.357 1.49284C18.2484 0.651586 17.5393 0 16.6794 0C16.5527 0 16.429 0.0152954 16.3113 0.0397682L3.86209 2.86025C2.4651 3.17533 1.39096 4.36532 1.23104 5.83368L0.012069 16.565C0.00603452 16.6292 0 16.6934 0 16.7607C0 17.7091 0.757332 18.4769 1.69268 18.4769H18.6135C19.5488 18.4769 20.3062 17.7091 20.3062 16.7607C20.3062 16.6843 20.3001 16.6109 20.2911 16.5374ZM10.1531 14.5337C7.66082 14.5337 5.63926 12.4841 5.63926 9.95733C5.63926 7.43053 7.66082 5.38094 10.1531 5.38094C12.6453 5.38094 14.6669 7.43053 14.6669 9.95733C14.6669 12.4841 12.6453 14.5337 10.1531 14.5337Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_6160_7303">
        <rect width="75" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const WordmarkLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={10} viewBox="0 0 32 10" fill="none" {...props}>
    <path
      fill="#535454"
      d="M13.0881 9.86178L13.0786 2.51953H10.8849V3.3091C10.3261 2.79909 9.57466 2.51953 8.67035 2.51953C6.83907 2.51953 5.35327 4.19501 5.35327 6.2596C5.35327 8.3242 6.83718 9.99967 8.67035 9.99967C9.75968 9.99967 10.4318 9.60677 10.8849 9.03065V9.86178H13.0881ZM9.18009 8.12964C8.23802 8.12964 7.47341 7.25506 7.47341 6.17649C7.47341 5.09791 8.23802 4.22334 9.18009 4.22334C10.1222 4.22334 10.8868 5.09791 10.8868 6.17649C10.8868 7.25506 10.1222 8.12964 9.18009 8.12964Z"
    />
    <path
      fill="#535454"
      d="M3.28121 7.74284C3.25666 8.29629 3.80416 8.24529 3.84003 8.24907H4.85196V9.86599C4.81797 9.86599 3.93254 9.86599 2.97725 9.86599C1.33287 9.86976 0.885436 8.55696 0.879772 8.30951V4.1841H0V2.51429H0.879772V0.663147H3.30009V2.51429H4.85007V4.1841H3.27366C3.27366 4.1841 3.27743 7.72584 3.27743 7.73906L3.28121 7.74284Z"
    />
    <path
      fill="#535454"
      d="M19.179 2.5066C18.1671 2.5066 17.3855 2.84283 16.8305 3.39817V0H14.3252V9.86774H16.8305V8.81372C17.4912 9.54473 18.3767 9.99997 19.179 9.99997C21.1614 9.99997 22.5546 8.3226 22.5546 6.25234C22.5546 4.18208 21.2425 2.50471 19.179 2.50471V2.5066ZM18.5315 8.0506C17.5913 8.0506 16.8305 7.21569 16.8305 6.18623C16.8305 5.15676 17.5913 4.32186 18.5315 4.32186C19.4717 4.32186 20.2325 5.15676 20.2325 6.18623C20.2325 7.21569 19.4717 8.0506 18.5315 8.0506Z"
    />
    <path
      fill="#535454"
      d="M28.49 2.5066C27.478 2.5066 26.6964 2.84283 26.1414 3.39817V0H23.6361V9.86774H26.1414V8.81372C26.8022 9.54473 27.6876 9.99997 28.49 9.99997C30.4723 9.99997 31.8656 8.3226 31.8656 6.25234C31.8656 4.18208 30.5534 2.50471 28.49 2.50471V2.5066ZM27.8424 8.0506C26.9022 8.0506 26.1414 7.21569 26.1414 6.18623C26.1414 5.15676 26.9022 4.32186 27.8424 4.32186C28.7826 4.32186 29.5434 5.15676 29.5434 6.18623C29.5434 7.21569 28.7826 8.0506 27.8424 8.0506Z"
    />
  </svg>
)

const Logo = memo(({ variant = "default", ...props }: LogoProps) => {
  if (variant === "with-icon") {
    return <LogoWithIcon {...props} />
  }
  if (variant === "wordmark") {
    return <WordmarkLogo {...props} />
  }
  return <DefaultLogo {...props} />
})

Logo.displayName = "Logo"

export default Logo
